<template>
  <div class="user-item">
    <div class="wrapper --selector-overlay-pointer" @click="setUser" :class="{active: $route.params.subId == data.id}">
      <div class="title">
        {{ data.firstName }}
      </div>
      <div class="location">
        {{ data.country }} {{ data.city }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
  },
  methods: {
    setUser () {
      this.$store.commit('subAccount/setActiveUser', this.data.id);
      this.$router.push('/dashboard/sub-accounts/' + this.data.id);
    }
  }
}
</script>

<style lang="scss" scoped>

.user-item {
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  border-bottom: 1px solid rgba(76, 80, 86, 0.10);

  .wrapper {
    padding: 8px 20px;
    z-index: 1;
    cursor: pointer;

    &.active {
      .title {
        color: #fff;
      }
      .location {
        color: #fff;
      }
    }
    .title {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 5px;

      transition: color 0.5s ease;
    }

    .location {
      color: #8B8D91;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.05em;
      margin-top: -3px;
      transition: color 0.5s ease;
    }
  }
}

</style>
